import React from 'react';
import '@/assets/styles/components/progress-bar.styles.scss';
import { ProgressBarProps } from './progress-bar.types.ts';

export const ProgressBar: React.FC<ProgressBarProps> = ({
	value = 0,
	height = 20,

	barColor = '#5eb3a6',
	backgroundColor = 'var(--surface-e0e0e0)',
	animated = true,
	label = false,
	className = '',
	width
}) => {
	const normalizedValue = Math.max(0, Math.min(100, value));

	return (
		<div
			className={`progress-bar-container ${className}`}
			style={{
				height: `${height}px`,
				width: width ? `${width}px` : '100%',
				backgroundColor
			}}>
			<div
				className={`progress-bar-fill ${animated ? 'animated' : ''}`}
				style={{
					width: `${normalizedValue}%`,
					backgroundColor: barColor
				}}>
				{label && <span className="progress-label">{normalizedValue}%</span>}
			</div>
		</div>
	);
};
